import { useCallback } from "react";
import {
  logBrowseTabClicked,
  logBrowseChemoRegimenListItemClicked,
} from "../../../util/analytics";

const normalizePath = (path) => path.split("/browse/").at(-1);

export const useTelemetry = ({ sharedTelemetryData, activeTab, history }) => {
  const onTabClick = useCallback(
    (tab) => {
      logBrowseTabClicked({
        navigateFrom: normalizePath(activeTab.path),
        navigateTo: normalizePath(tab.path),
      });
      history.push(tab.path);
    },
    [activeTab, history]
  );

  const onListItemClick = useCallback(
    (item) => {
      logBrowseChemoRegimenListItemClicked({
        browseType: sharedTelemetryData.browseType,
        categoryId: item.name,
      });
    },
    [sharedTelemetryData]
  );

  return {
    onTabClick,
    onListItemClick,
  };
};
